import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NbMenuService, NbMenuItem } from '@nebular/theme';
import { Patient } from 'src/app/models/Patient';
import { AuthenticationService } from 'src/app/shared/auth.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-container',
  templateUrl: './container.component.html',
  styleUrls: ['./container.component.scss'],
  providers: [NbMenuService]
})
export class ContainerComponent {
  items: NbMenuItem[];
  patients: Patient[] = [];
  patient: Patient;
  constructor(
    private authService: AuthenticationService,
    private router: Router
    ) {
    this.items = [
      {
        title: 'Laboratory Reports',
        link: '/patient-portal/lab-reports'
      },
      {
        title: 'Radiology Reports',
        link: '/patient-portal/radiology-reports'
      },
      {
        title: 'Feedback',
        link: '/patient-portal/feedback'
      }
    ]
    const decodedtoken = this.authService.getDecodedToken();
    if(decodedtoken['patients']) {
      decodedtoken['patients'].forEach(patient => {
        this.patients.push(new Patient(patient))
      })
    }
    if(this.patients.length > 0) {
      this.patient = this.patients[0];
    }
  }

  logout() {
    this.authService.logout();
    if (environment.production) {
      location.href = "/home/patient-login"
    } else {
      this.router.navigate(['/patient-login']);
    }
  }
}
